<template>
	<div class="bottom_slider">
		<div class="show">
			<img class="img" src="../assets/img/at0.jpg" alt="" />
			<img class="img" src="../assets/img/at_1.jpg" alt="" />
			<img class="img" src="../assets/img/at_2.jpg" alt="" />
			<img class="img" src="../assets/img/at_3.jpg" alt="" />
			<img class="img" src="../assets/img/at_4.jpg" alt="" />
			<img class="img" src="../assets/img/at_5.jpg" alt="" />
		</div>

		<div class="swiper-container">
			<div class="swiper-wrapper">
					<a href="#/show" target="_blank" class="swiper-slide"><img src="../assets/img/b1.png" alt="" /></a>
					<a href="#/show" class="swiper-slide"><img src="../assets/img/b2.png" alt="" /></a>
					<a href="#/show" class="swiper-slide"><img src="../assets/img/b3.png" alt="" /></a>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper';
	export default{
		data(){
			return {

			}
		},
		
		mounted(){
			var mySwiper = new Swiper('.swiper-container', {
				effect: 'coverflow', //3d滑动
				grabCursor: true,
				centeredSlides: true,
				loop: true,
				slidesPerView: 3,
				coverflow: {
					rotate: 50,
			        stretch: 0,
			        depth: 100,
			        modifier: 1,
			        slideShadows:true,
				}
			});		

		}
	}
</script>

<style scoped>
	.show{
		padding-top: 241px;
		width: 1248px;
		margin: 0 auto; padding-bottom: 80px;
	}
	.show img{ display: block; margin: 0 auto; }
	.swiper-container {
	    width:855px;
	}
	.swiper-slide img {
	    width: 285px;
	    height: 335px;
	}
	.bottom_slider{
		margin-bottom: 50px;
	}
</style>


// WEBPACK FOOTER //
// src/views/show2.vue